import React from 'react';

import t from '../lib/translate';

const Warning = ({ message, className }) => (
  <div className={`warning ${className}`}>{t(message)}</div>
);

export default Warning;
